import { render, staticRenderFns } from "./topicSelect.vue?vue&type=template&id=21e7a442&scoped=true&"
import script from "./topicSelect.vue?vue&type=script&lang=js&"
export * from "./topicSelect.vue?vue&type=script&lang=js&"
import style0 from "./topicSelect.vue?vue&type=style&index=0&id=21e7a442&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e7a442",
  null
  
)

export default component.exports